import { PropsWithChildren, useEffect } from 'react'
import useScopes from '../../hooks/useScopes'
import { UnauthorizedRequestError } from 'models/errors'

export default function RolesGate({ children }: PropsWithChildren) {
  const scopes = useScopes()

  useEffect(() => {
    if (!scopes.hasPermission()) {
      throw new UnauthorizedRequestError('Unauthorized')
    }
  }, [scopes])

  return <>{children}</>
}
